<div *ngIf="!filterPopupOnly" class="p-mb-0" style="height: auto !important;" [ngClass]="{'card': showCardStyle}">
    <div class="p-d-flex p-jc-between">
        <ng-container *ngTemplateOutlet="dynamicFilters"></ng-container>
        <ng-template #dynamicFilters>
            <div class="p-grid" style="flex-grow: 1;">
                <ng-container *ngIf="!hideDateFilter">
                    <div class="p-col-2">
                        <p-dropdown [options]="filterDataByTime" id="rangeItems" [style]="{'width':'100%'}"
                            (onChange)="changeRange()" [(ngModel)]="selectedDateFilter" optionLabel="label" appendTo="body"
                            placeholder="Select Time">
                        </p-dropdown>
                    </div>
                    <div class="p-col-1" *ngIf="(apiName !== 'InventoryCustomers' && apiName !== 'InventoryVendor')">
                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                            dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="dateFrom" [maxDate]="dateTo"
                            [disabled]="(selectedDateFilter?.code !== 'Custom') && (selectedDateFilter?.code !== 'custom')"
                            (onSelect)="onSelectFromDate($event)">
                        </p-calendar>
                    </div>
                    <div class="p-col-1">
                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                            dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="dateTo" [minDate]="dateFrom"
                            [disabled]="(selectedDateFilter?.code !== 'Custom') && (selectedDateFilter?.code !== 'custom')"
                            (onSelect)="onSelectToDate($event)">
                        </p-calendar>
                    </div>
                </ng-container>
                <div *ngIf="showOpportunityChannelFilter" class="p-col-2">
                    <p-dropdown [options]="opportunityChannelList" id="opportunityChannelList"
                        [style]="{'width':'100%'}" (onChange)="changeOpportunityChannel($event)"
                        [(ngModel)]="selectedOpportunityChannel" optionLabel="name" appendTo="body"
                        placeholder="Select Opportunity Channel">
                    </p-dropdown>
                </div>
                <div *ngIf="showModuleFilter" class="p-col-2">
                    <p-dropdown [options]="moduleList" id="moduleList" [style]="{'width':'100%'}"
                        (onChange)="changeModule($event)" [(ngModel)]="selectedModule" optionLabel="name"
                        appendTo="body" placeholder="Select Module">
                    </p-dropdown>
                </div>
                <div *ngIf="showChannelFilter" class="p-col-2">
                    <p-dropdown [options]="channelList" id="channelList" [style]="{'width':'100%'}"
                        (onChange)="changeChannel($event)" [(ngModel)]="selectedChannel" optionLabel="name"
                        appendTo="body" placeholder="Select Channel">
                    </p-dropdown>
                </div>
                <div *ngIf="showWarehouseLocationFilter" class="p-col-2">
                    <p-dropdown [options]="warehouseLocationList" id="warehouseLocationList" [style]="{'width':'100%'}"
                        (onChange)="onChangeWarehouseLocation($event)" [(ngModel)]="selectedWarehouseLocation"
                        optionLabel="locationId" appendTo="body" placeholder="Select Location" [filter]="true"
                        [resetFilterOnHide]="true">
                    </p-dropdown>
                </div>
                <ng-container *ngIf="filterGroup.length > 0">
                    <div class="p-col-1" *ngFor="let s of filterGroup; let i = index;">
                        <div class="p-buttonset" style="white-space: nowrap; width: 100%;">
                            <!-- <ng-container [ngSwitch]="s?.dataType">
                                <ng-container *ngSwitchCase="'datetime'">
                                    <button pButton pRipple [label]="(s?.value | localDate)"
                                        class="p-button-outlined p-button-secondary p-px-1" style="width: 68%;"
                                        [pTooltip]="(s?.category ? s?.category + ': ' : '') + (s?.value | localDate)" tooltipPosition="top"
                                        (click)="editFilter(s);addFilter=false;"></button>
                                </ng-container>
                                <ng-container *ngSwitchCase="'timespan'">
                                    <button pButton pRipple [label]="(s?.value | timeConvert)"
                                        class="p-button-outlined p-button-secondary p-px-1" style="width: 68%;"
                                        [pTooltip]="(s?.category ? s?.category + ': ' : '') + (s?.value | timeConvert)" tooltipPosition="top"
                                        (click)="editFilter(s);addFilter=false;"></button>
                                </ng-container>
                                <ng-container *ngSwitchCase="'secsdhms'">
                                    <button pButton pRipple [label]="(s?.value | secsToDhms)"
                                        class="p-button-outlined p-button-secondary p-px-1" style="width: 68%;"
                                        [pTooltip]="(s?.category ? s?.category + ': ' : '') + (s?.value | secsToDhms)" tooltipPosition="top"
                                        (click)="editFilter(s);addFilter=false;"></button>
                                </ng-container>
                                <ng-container *ngSwitchCase="'currencySymbol'">
                                    <button pButton pRipple [label]="(s?.value | currencySymbol:'number2dp')"
                                        class="p-button-outlined p-button-secondary p-px-1" style="width: 68%;"
                                        [pTooltip]="(s?.category ? s?.category + ': ' : '') + (s?.value | currencySymbol:'number2dp')" tooltipPosition="top"
                                        (click)="editFilter(s);addFilter=false;"></button>
                                </ng-container>
                                <ng-container *ngSwitchCase="'percentageSymbol'">
                                    <button pButton pRipple [label]="(s?.value | percentageSymbol)"
                                        class="p-button-outlined p-button-secondary p-px-1" style="width: 68%;"
                                        [pTooltip]="(s?.category ? s?.category + ': ' : '') + (s?.value | percentageSymbol)" tooltipPosition="top"
                                        (click)="editFilter(s);addFilter=false;"></button>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <button pButton pRipple label="{{s?.value}}"
                                        class="p-button-outlined p-button-secondary p-px-1" style="width: 68%;"
                                        [pTooltip]="(s?.category ? s?.category + ': ' : '') + ((s?.value=='Custom' && s?.dateRangeTo && s?.dateRangeFrom)? ((s?.dateRangeFrom | date:'MM/dd/yyyy') +' - '+ (s?.dateRangeTo | date:'MM/dd/yyyy')) : (s?.value))" tooltipPosition="top"
                                        (click)="editFilter(s);addFilter=false;"></button>
                                </ng-container>
                            </ng-container> -->
                            <button pButton pRipple label="{{s?.previewValue}}"
                                class="p-button-outlined p-button-secondary p-px-1" style="width: 68%;"
                                [pTooltip]="(s?.category ? s?.category + ': ' : '') + ((s?.value=='Custom' && s?.dateRangeTo && s?.dateRangeFrom)? ((s?.dateRangeFrom | date:'MM/dd/yyyy') +' - '+ (s?.dateRangeTo | date:'MM/dd/yyyy')) : (s?.previewValue))" tooltipPosition="top"
                                (click)="editFilter(s);addFilter=false;">
                            </button>
                            <button pButton pRipple [disabled]="s?.notRemovable" icon="pi pi-times"
                                (click)="removeFilter(s,i)" class="p-button-outlined p-button-secondary"></button>
                        </div>
                    </div>
                </ng-container>
                <div class="p-col-fixed" style="width:100px" [class.p-ml-2] = "filterGroup.length > 0">
                    <p-button label="Filter" icon="pi pi-plus" iconPos="right"
                        (click)="op.toggle($event);addFilter=true;modifyColumnFilterBy();editFlag=false;"></p-button>
                </div>

                <div class="p-col-fixed" style="width:100px" [class.p-ml-2] = "filterGroup.length > 0" *ngIf="showGroupByFilter">
                    <p-button label="Group" icon="pi pi-plus" iconPos="right"
                        (click)="onGroupByClick(groupBy,$event)"></p-button>
                </div>

                <div class="p-col-fixed" style="width:110px" [class.p-ml-2] = "filterGroup.length > 0" *ngIf="showOrderByFilter">
                    <p-button label="Order By" icon="pi pi-plus" iconPos="right"
                        (click)="onOrderByClick(orderBy,$event)"></p-button>
                </div>
            </div>
        </ng-template>


        <!-- <p-dropdown panelStyleClass="fav-dropdown" [options]="fav" optionLabel="name" (onChange)="changeFav($event)" class="filterDD"
        placeholder="Select Fav"></p-dropdown> -->

    </div>

    <p-dialog header="Create New Fav" [(visible)]="displayAddFav" [modal]="true" [responsive]="true"
        [style]="{width: '80vw'}">
        <div class="card">
            <h6>Added Filters</h6>
            <div class="p-d-flex p-jc-between">
                <ng-container *ngTemplateOutlet="dynamicFilters"></ng-container>
            </div>
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-6">
                    <label>Group</label>
                    <p-dropdown [options]="groups" optionLabel="name" placeholder="Select Group"
                        (onChange)="changeGroup($event)" appendTo="body" [(ngModel)]="selectedGroup"></p-dropdown>
                </div>
                <div class="p-col-6">
                    <label>Report Name</label>
                    <input type="text" pInputText [(ngModel)]="reportName">
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton (click)="displayAddFav=false;" label="Cancel" class="p-button-secondary"></button>
            <button pButton label="Save" (click)="saveFav(reportName)"></button>
        </ng-template>
    </p-dialog>

    <p-dialog header="Create New Group" [(visible)]="displayAddGroup" [modal]="true" [responsive]="true"
        [style]="{width: '45vw'}">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Group Name</label>
                    <input type="text" pInputText [(ngModel)]="groupName">
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton (click)="displayAddGroup=false;" label="Cancel" class="p-button-secondary"></button>
            <button pButton label="Save" (click)="saveGroup(groupName)"></button>
        </ng-template>
    </p-dialog>

</div>

<p-overlayPanel #op [showCloseIcon]="true" [style]="{width: '300px'}" (onHide)="closePanel()"
styleClass="panel-in-dialog" *ngIf="panelDialog">
    <ng-template pTemplate>
        <label>Filter By</label>
        <p-dropdown [options]="filterBy" class="panelDD" (onChange)="changeFilterOptions()"
            [(ngModel)]="selectedFilterBy" optionLabel="header" placeholder="Select Item">
        </p-dropdown>
        <label>Options</label>
        <p-dropdown [options]="vertualFilterOptions" class="panelDD" [(ngModel)]="selectedFilterOption"
            optionLabel="name" [filter]="true" (onFocus)="onShowFilter($event)" (onFilter)="optionsFilter($event)"
            placeholder="Select Item">
            <ng-template let-obj pTemplate="selectedItem">
                <ng-container [ngSwitch]="selectedFilterBy?.dataType">
                    <ng-container *ngSwitchCase="'string'">
                        <span pTooltip="{{obj.name}}" tooltipPosition="top">
                            {{ obj.name | removeHtmlTags | shorten:40 }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'datetime'">
                        {{ obj.name | localDate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'time'">
                        {{ obj.name | onlyTime }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'timespan'">
                        {{ obj.name | timeConvert }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ obj.name | currencySymbol:'number2dp' }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ obj.name | percentageSymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'secsdhms'">
                        {{ obj.name | secsToDhms }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ obj.name }}
                    </ng-container>
                </ng-container>
            </ng-template>
            <ng-template let-obj pTemplate="item">
                <ng-container [ngSwitch]="selectedFilterBy?.dataType">
                    <ng-container *ngSwitchCase="'string'">
                        <span pTooltip="{{obj.name}}" tooltipPosition="top">
                            {{ obj.name | removeHtmlTags | shorten:40 }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'datetime'">
                        {{ obj.name | localDate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'time'">
                        {{ obj.name | onlyTime }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'timespan'">
                        {{ obj.name | timeConvert }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ obj.name | currencySymbol:'number2dp' }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ obj.name | percentageSymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'secsdhms'">
                        {{ obj.name | secsToDhms }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ obj.name }}
                    </ng-container>
                </ng-container>
            </ng-template>
        </p-dropdown>
        <div class="p-text-right">
            <p-button label="Apply" class="p-mt-2" (onClick)="applyFilter()" *ngIf="addFilter"
                [disabled]="!selectedFilterBy || !selectedFilterOption"></p-button>
            <p-button label="Apply" class="p-mt-2" (onClick)="saveFilter()" *ngIf="!addFilter"
                [disabled]="!selectedFilterBy || !selectedFilterOption"></p-button>
        </div>
    </ng-template>
</p-overlayPanel>

<p-overlayPanel #op [showCloseIcon]="true" [style]="{width: '300px'}" (onHide)="closePanel()"
*ngIf="!panelDialog">
    <ng-template pTemplate>
        <label>Filter By</label>
        <p-dropdown [options]="filterBy" class="panelDD" (onChange)="changeFilterOptions(true, true);addFilter=true;"
            [(ngModel)]="selectedFilterBy" [filter]="true" [resetFilterOnHide]="true" optionLabel="header" placeholder="Select Item">
        </p-dropdown>
        <label>Options</label>
        <ng-container *ngIf="multiSelectFilter && selectedFilterBy?.dataType != 'date'">
            <p-multiSelect [options]="vertualFilterOptions" class="panelDD" [(ngModel)]="selectedFilterOption"
            optionLabel="name" dataKey="name" [filter]="true" (onFilter)="optionsFilter($event,true)" (onChange)="changeFilterOptionValue($event)"
            appendTo="body" placeholder="Select Item">
                <ng-template let-obj pTemplate="selectedItem">
                    <ng-container [ngSwitch]="selectedFilterBy?.dataType">
                        <ng-container *ngSwitchCase="'string'">
                            <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                {{ obj.name | removeHtmlTags | shorten:40 }}
                            </span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ obj.name | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'time'">
                            {{ obj.name | onlyTime }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'timespan'">
                            {{ obj.name | timeConvert }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbol'">
                            {{ obj.name | currencySymbol:'number2dp' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'percentageSymbol'">
                            {{ obj.name | percentageSymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'secsdhms'">
                            {{ obj.name | secsToDhms }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ obj.name }}
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template let-obj pTemplate="item">
                    <ng-container [ngSwitch]="selectedFilterBy?.dataType">
                        <ng-container *ngSwitchCase="'string'">
                            <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                {{ obj.name | removeHtmlTags | shorten:40 }}
                            </span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ obj.name | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'time'">
                            {{ obj.name | onlyTime }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'timespan'">
                            {{ obj.name | timeConvert }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbol'">
                            {{ obj.name | currencySymbol:'number2dp' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'percentageSymbol'">
                            {{ obj.name | percentageSymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'secsdhms'">
                            {{ obj.name | secsToDhms }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ obj.name }}
                        </ng-container>
                    </ng-container>
                </ng-template>
            </p-multiSelect>
        </ng-container>
        <ng-container *ngIf="!multiSelectFilter || selectedFilterBy?.dataType == 'date'">
            <p-dropdown [options]="vertualFilterOptions" class="panelDD" [(ngModel)]="selectedFilterOption"
            optionLabel="name" [filter]="true" (onFocus)="onShowFilter($event)" (onFilter)="optionsFilter($event)" (onChange)="changeFilterOptionValue($event)"
            placeholder="Select Item">
                <ng-template let-obj pTemplate="selectedItem">
                    <ng-container [ngSwitch]="selectedFilterBy?.dataType">
                        <ng-container *ngSwitchCase="'string'">
                            <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                {{ obj.name | removeHtmlTags | shorten:40 }}
                            </span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ obj.name | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'time'">
                            {{ obj.name | onlyTime }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'timespan'">
                            {{ obj.name | timeConvert }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbol'">
                            {{ obj.name | currencySymbol:'number2dp' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'percentageSymbol'">
                            {{ obj.name | percentageSymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'secsdhms'">
                            {{ obj.name | secsToDhms }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ obj.name }}
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template let-obj pTemplate="item">
                    <ng-container [ngSwitch]="selectedFilterBy?.dataType">
                        <ng-container *ngSwitchCase="'string'">
                            <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                {{ obj.name | removeHtmlTags | shorten:40 }}
                            </span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ obj.name | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'time'">
                            {{ obj.name | onlyTime }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'timespan'">
                            {{ obj.name | timeConvert }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbol'">
                            {{ obj.name | currencySymbol:'number2dp' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'percentageSymbol'">
                            {{ obj.name | percentageSymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'secsdhms'">
                            {{ obj.name | secsToDhms }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ obj.name }}
                        </ng-container>
                    </ng-container>
                </ng-template>
            </p-dropdown>
        </ng-container>
        <div class="p-grid" *ngIf="selectedFilterBy?.dataType == 'date' && dateRangeForDatetime && selectedFilterOption?.code">
            <div class="p-col-6">
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="dateRangeFrom" [maxDate]="dateRangeTo"
                    [disabled]="selectedFilterOption?.code !== 'custom'">
                </p-calendar>
            </div>
            <div class="p-col-6">
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="dateRangeTo" [minDate]="dateRangeFrom"
                    [disabled]="selectedFilterOption?.code !== 'custom'">
                </p-calendar>
            </div>
        </div>
        <div class="p-text-right">
            <p-button label="Apply" class="p-mt-2" (onClick)="applyFilter()" *ngIf="addFilter && !editFlag"
                [disabled]="!selectedFilterBy || !selectedFilterOption || (multiSelectFilter && selectedFilterBy?.dataType != 'date' && selectedFilterOption?.length==0) || (selectedFilterOption?.code == 'custom' && (!dateRangeTo || !dateRangeFrom))"></p-button>
            <p-button label="Apply" class="p-mt-2" (onClick)="saveFilter()" *ngIf="!addFilter || editFlag"
                [disabled]="!selectedFilterBy || !selectedFilterOption || (multiSelectFilter && selectedFilterBy?.dataType != 'date' && selectedFilterOption?.length==0) || (selectedFilterOption?.code == 'custom' && (!dateRangeTo || !dateRangeFrom))"></p-button>
        </div>
    </ng-template>
</p-overlayPanel>

<p-overlayPanel #groupBy [showCloseIcon]="true" [style]="{width: '300px'}" (onHide)="closePanel()" *ngIf="!panelDialog">
    <ng-template pTemplate>
        <label>Group By</label>
        <p-dropdown [options]="groupByFilter | ssGroupByFields:selectedSubGroupBy" class="panelDD" [filter]="true" [showClear]="true" (onChange)="onChangeGroupBy()"
            [(ngModel)]="selectedGroupBy" optionLabel="header" placeholder="Select Field">
        </p-dropdown>
        <label>Sub Group By</label>
        <p-dropdown [options]="groupByFilter | ssGroupByFields:selectedGroupBy" class="panelDD" [filter]="true" [showClear]="true"
            [(ngModel)]="selectedSubGroupBy" [disabled]="!selectedGroupBy" optionLabel="header" placeholder="Select Field">
        </p-dropdown>
        <label>Summary Fields</label>
        <p-multiSelect [options]="aggregateFields" class="panelDD" [filter]="true"
            [(ngModel)]="selectedAggregateBy" (onChange)="setAggTypes()" optionLabel="header" appendTo="body" placeholder="Select Fields">
        </p-multiSelect>
        <label>Summary Value</label>
        <p-dropdown [options]="aggregateTypesCopy" class="panelDD"  [filter]="true" optionLabel="type"
            [(ngModel)]="selectedAggregateTypeBy" [disabled]="selectedAggregateBy?.length==0" placeholder="Select Value Type">
        </p-dropdown>
        <div class="p-text-right">
            <p-button label="Reset" class="p-mt-2 p-mr-2" (click)="resetGroup()"
             [disabled]="!(selectedGroupBy || selectedAggregateBy?.length>0)"></p-button>
            <p-button label="Save" class="p-mt-2" (onClick)="applyGroup()"
                [disabled]="!(selectedGroupBy || selectedAggregateBy?.length>0)"></p-button>
        </div>
    </ng-template>
</p-overlayPanel>

<p-overlayPanel #orderBy [showCloseIcon]="true" [style]="{width: '300px'}" (onHide)="closePanel()" *ngIf="!panelDialog">
    <ng-template pTemplate>
        <label>Order By</label>
        <p-dropdown [options]="filterBy" class="panelDD" [filter]="true" [showClear]="true" (onChange)="checkTopNumberOfRecordsDisabled()"
            [(ngModel)]="selectedOrderField" optionLabel="header" dataKey="id" placeholder="Select Field">
        </p-dropdown>
        <p-dropdown [options]="orderByTypes" class="panelDD" styleClass="p-mt-0" [(ngModel)]="selectedOrderByType" optionLabel="name" dataKey="id" placeholder="Select Order">
        </p-dropdown>

        <label>Top number of records</label>
        <p-inputNumber [min]="1" [(ngModel)]="topNumberOfRecords" class="p-mb-3 p-mt-2 w-100" styleClass="w-100" [placeholder]="topNumberOfRecordsDisabled ? 'Limit availble for Group and Summary fields' :'Leave empty for all records'" [disabled]="topNumberOfRecordsDisabled"></p-inputNumber>
        <div class="p-text-right">
            <p-button label="Reset" class="p-mt-2 p-mr-2" (click)="resetOrderBy()"></p-button>
            <p-button label="Save" class="p-mt-2" (onClick)="applyOrderBy()"></p-button>
        </div>
    </ng-template>
</p-overlayPanel>

<p-dialog [header]="filterPopupHeader" (onHide)="cancelFilterPopup()" [(visible)]="displayFilterPopup" [modal]="true"
    [style]="{width: '400px'}" appendTo="body">
    <ng-template pTemplate="content">
        <div class="p-grid" style="flex-grow: 1;">
            <div class="p-col-12" *ngIf="!showTerritoryChannelFilter">
                <h6 class="p-mb-1">Select Date</h6>
                <p-dropdown [options]="filterDataByTime" id="rangeItems" [style]="{'width':'100%'}"
                    (onChange)="changeRange(false)" [(ngModel)]="selectedDateFilter" optionLabel="label" appendTo="body"
                    placeholder="Select Time">
                </p-dropdown>
            </div>
            <div class="p-col-6" *ngIf="!showTerritoryChannelFilter">
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="dateFrom"
                    [disabled]="selectedDateFilter?.code !== 'custom'" [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}">
                </p-calendar>
            </div>
            <div class="p-col-6" *ngIf="!showTerritoryChannelFilter">
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="MM/DD/YYYY"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="dateTo"
                    [disabled]="selectedDateFilter?.code !== 'custom'" [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}">
                </p-calendar>
            </div>
            <div *ngIf="showOpportunityChannelFilter" class="p-col-12">
                <h6 class="p-mb-1">Select Opportunity Channel</h6>
                <p-dropdown [options]="opportunityChannelList" id="opportunityChannelList" [style]="{'width':'100%'}"
                    [(ngModel)]="selectedOpportunityChannel" optionLabel="name" appendTo="body"
                    placeholder="Select Opportunity Channel">
                </p-dropdown>
            </div>
            <div *ngIf="showChannelFilter" class="p-col-12">
                <h6 class="p-mb-1">Select Channel</h6>
                <p-dropdown [options]="channelList" id="channelList" [style]="{'width':'100%'}"
                    [(ngModel)]="selectedChannel" optionLabel="name" appendTo="body" placeholder="Select Channel">
                </p-dropdown>
            </div>
            <div *ngIf="showWarehouseLocationFilter" class="p-col-12">
                <h6 class="p-mb-1">Select Warehouse</h6>
                <p-dropdown [options]="warehouseLocationList" id="warehouseLocationList" [style]="{'width':'100%'}"
                    [(ngModel)]="selectedWarehouseLocation" optionLabel="locationId" appendTo="body"
                    placeholder="Select Location">
                </p-dropdown>
            </div>
            <div *ngIf="showTerritoryChannelFilter" class="p-col-12">
                <h6 class="p-mb-1">Select Channel</h6>
                <p-dropdown [options]="channelList" id="channelList" [style]="{'width':'100%'}"
                    [(ngModel)]="selectedChannel" (onChange)="changeChannel($event)" optionLabel="name" appendTo="body" placeholder="Select Channel">
                </p-dropdown>
            </div>
            <div *ngIf="showTerritoryChannelFilter" class="p-col-12">
                <h6 class="p-mb-1">Select Territory Name </h6>
                <liono-treeSelect  [(ngModel)]="selectedTerritory" [style]="{'width':'100%', 'max-height':'20px'}" [options]="territoryNamesList" [disabled]="routeViewOnly ||selectedTerritoryForRoute?.id > 0"
                    (onNodeSelect)="changeTerritory($event)" appendTo="body"
                    placeholder="Select Territory" emptyMessage="Select Territory" [filter]="true" [metaKeySelection]="false"
                    [filterInputAutoFocus]="true">
                </liono-treeSelect>
            </div>
        </div>
    </ng-template>
    <p-footer>
        <button type="button" pButton label="Cancel" (click)="cancelFilterPopup()" class="p-button-secondary"></button>
        <button type="submit" pButton label="Apply"
            (click)="applyAllFilters(reportsAllFiltersApplyModes.applyOnly)"></button>
        <button type="submit" pButton label="Apply & Save"
            (click)="applyAllFilters(reportsAllFiltersApplyModes.applySave)"></button>
    </p-footer>
</p-dialog>
